import { Modal } from "@shop/frontend/web/js/components/Modal";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { utils } from "../../../../../shop/frontend/web/js/utils";

export class EventView {
	constructor() {
		this.$popupModal = null;
		this.$placesContainer = $("#js-places");
		this.modal = new Modal({ className: "i-modal_mobile-fixed", id: "popup-event" });
		this.childAlert = new Modal({ className: "i-modal_child-info", id: "child-modal" });
	}

	getPlacesSettings() {
		const settings = {};

		if (this.$placesContainer.attr("data-show-free-places") === "0")
			settings.showFreePlaces = false;
		if (this.$placesContainer.attr("data-price-filter-type"))
			settings.planPriceFilterType = parseInt(
				this.$placesContainer.attr("data-price-filter-type")
			);
		if (this.$placesContainer.attr("data-has-child-ticket") === "true")
			settings.hasChildTicket = true;

		return settings;
	}

	showEventOnPopup() {
		let places = $("#js-places");
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = places.appendTo("<div></div>").html();
		this.modal.show(htmlObject);
		this.$popupModal = $(".i-modal_mobile-fixed");
		this.$popupModal.find(".places__content").wrap("<div id='js-places'></div>");
		this.$popupModal.find(".places__top").show();

		this.$popupModal.find(".places__middle").append($(".js-stadium-zones"));
		this.$popupModal.find(".places__middle").append($(".js-places-prices"));
		this.$popupModal.find(".places__limit-wrapper").prepend($("#js-fan-id-alert"));
		const closeButton = this.$popupModal.find(".i-modal__close");

		closeButton.removeAttr("data-bs-dismiss");
		closeButton.on("click", () => {
			window.location.assign("/");
		});
	}

	returnEventFromPopup() {
		$(".events_page").after($("#js-places"));

		$("#js-places-check-price").after($(".js-stadium-zones"));
		$("#js-places-check-price").after($(".js-places-prices"));

		$(".places__top").hide();
		this.$popupModal.find(".modal-body").html("");
		this.$popupModal.removeClass("i-modal_mobile-fixed");
		this.$popupModal.modal("hide");
	}

	getPopupSettings() {
		const id = document.location.href
			.match(/id_event=([0-9]+)/g)?.[0]
			?.match(/[0-9]/g)
			?.join('');

		if (!id) {
			console.log("Не удалось извлечь ID события из URL");
		}

		return utils.request(
			`/event/get-loyalty-popup?id=${id}`,
			null,
			"GET",
			true,
			false,
			true,
			30000
		);
	}

	showChildTicketInfo() {
		if (document.location.href.includes('event')) {
			this.getPopupSettings()
				.then(res => {
					if (!localStorage.getItem("change_price_id_alert") && res.presence) {
						const isSeason = $(".events_page").data("is-season");
						const word = isSeason ? "абонемент" : "билет";
						const text = res.messages[0];
						this.childAlert.show(
							`
							<h3 class="i-modal__title">Обратите внимание!</h3>
							<p class="mb-0">${text}</p>
							<label class="checkbox d-inline-flex">
							<input type="checkbox" name="show_price_id_alert_discount" class="checkbox__input" checked />
							<span class="checkbox__custom"></span>
							<span class="checkbox__block ml-2">Не показывать это сообщение</span>
							</label>
							<br>
							<button class="btn btn_secondary js-price-id-alert-btn" data-bs-dismiss="modal">Продолжить</button>
						`
						);

						$(".js-price-id-alert-btn").on("click", () => {
							if ($("input[name='show_price_id_alert_discount']").is(":checked")) {
								localStorage.setItem("change_price_id_alert", "true");
							}
						});
					}
				})
				.catch(err => console.log(err));
		}
	}
}
